module.exports = __webpack_public_path__ + "static/media/10_of_spades.0c77f42a.png";